export default "/images/vendor/flag-icon-css/flags/4x3/gg.svg?9f0be4b0947f82e770ea234ba222d891";